export { default as Footer } from './Footer/Footer';
export { default as FooterBottomLine } from '@/components/footer/FooterBottomLine/FooterBottomLine';
export { default as FooterSticky } from './FooterSticky/FooterSticky';
